import React from "react";
import GitHubCalendar from "react-github-calendar";
import './Github.css'
// import { Row } from "react-bootstrap";

function Github() {
  return (
   <div className="container">
    <h1> My Github Stats </h1>
    <br/>
    <br/>
    <GitHubCalendar
        username="Sukanta1304"
        blockSize={15}
        blockMargin={5}
        color="green"
        fontSize={16}
      />
   </div>
      
  );
}

export default Github;
